import { useEffect, useState } from "react";
import "./HeroSlider.css";
import API_BASE_URL from "../config/config";


function HeroSlider() {

    const [slides, setSlides] = useState([]);

    const [current, setCurrent] = useState(0);

    const [loading, setLoading] = useState(true);

    const [direction, setDirection] = useState("next");

    const [isAnimating, setIsAnimating] = useState(false);


    /*
    |--------------------------------------------------------------------------
    | Fetch Sliders - PUBLIC API
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const fetchSliders = async () => {

            try {

                const response = await fetch(
                    `${API_BASE_URL}/sliders`
                );


                console.log(
                    "Slider API Status:",
                    response.status
                );


                const text = await response.text();


                console.log(
                    "Slider API Response:",
                    text
                );


                let data;


                try {

                    data = JSON.parse(text);

                } catch (jsonError) {

                    throw new Error(
                        `Server returned invalid JSON. HTTP Status: ${response.status}`
                    );

                }


                if (!response.ok) {

                    throw new Error(
                        data.message ||
                        `Failed to fetch sliders (${response.status})`
                    );

                }


                if (data.success) {

                    const sliderData = data.sliders || [];

                    setSlides(sliderData);

                    setCurrent(0);

                } else {

                    setSlides([]);

                    console.warn(
                        "Slider API returned success=false:",
                        data
                    );

                }

            } catch (error) {

                console.error(
                    "Slider API Error:",
                    error
                );

                setSlides([]);

            } finally {

                setLoading(false);

            }

        };


        fetchSliders();

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Change Slide
    |--------------------------------------------------------------------------
    */

    const changeSlide = (
        newIndex,
        slideDirection = "next"
    ) => {

        if (
            slides.length <= 1 ||
            isAnimating ||
            newIndex === current
        ) {
            return;
        }


        setDirection(slideDirection);

        setIsAnimating(true);

        setCurrent(newIndex);


        setTimeout(() => {

            setIsAnimating(false);

        }, 800);

    };


    /*
    |--------------------------------------------------------------------------
    | Next Slide
    |--------------------------------------------------------------------------
    */

    const nextSlide = () => {

        if (slides.length <= 1) {
            return;
        }


        const nextIndex =
            current >= slides.length - 1
                ? 0
                : current + 1;


        changeSlide(
            nextIndex,
            "next"
        );

    };


    /*
    |--------------------------------------------------------------------------
    | Previous Slide
    |--------------------------------------------------------------------------
    */

    const prevSlide = () => {

        if (slides.length <= 1) {
            return;
        }


        const previousIndex =
            current === 0
                ? slides.length - 1
                : current - 1;


        changeSlide(
            previousIndex,
            "prev"
        );

    };


    /*
    |--------------------------------------------------------------------------
    | Automatic Slider
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        if (slides.length <= 1) {
            return;
        }


        const interval = setInterval(() => {

            if (!isAnimating) {

                const nextIndex =
                    current >= slides.length - 1
                        ? 0
                        : current + 1;


                changeSlide(
                    nextIndex,
                    "next"
                );

            }

        }, 5000);


        return () => clearInterval(interval);

    }, [
        slides,
        current,
        isAnimating
    ]);


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (

            <section className="hero-slider">

                <div className="hero-container">

                    <div className="slider-loading">
                        Loading...
                    </div>

                </div>

            </section>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | No Slider
    |--------------------------------------------------------------------------
    */

    if (slides.length === 0) {

        return null;

    }


    /*
    |--------------------------------------------------------------------------
    | Current Slide
    |--------------------------------------------------------------------------
    */

    const slide = slides[current];


    return (

        <section className="hero-slider">

            <div
                key={slide.id}
                className={`hero-slide ${
                    direction === "next"
                        ? "slide-next"
                        : "slide-prev"
                }`}
            >

                <div className="hero-container">


                    {/* LEFT CONTENT */}

                    <div className="hero-content">


                        {/* Badge */}

                        {slide.badge && (

                            <div className="badge-custom">

                                {slide.badge}

                            </div>

                        )}


                        {/* Title */}

                        {slide.title && (

                            <h1>

                                {slide.title}

                            </h1>

                        )}


                        {/* Description */}

                        {slide.description && (

                            <p>

                                {slide.description}

                            </p>

                        )}


                    </div>


                    {/* RIGHT IMAGE */}

                    <div className="hero-image">

                        {slide.image_url && (

                            <img
                                src={slide.image_url}
                                alt={
                                    slide.title ||
                                    "HomoeoAdda Slider"
                                }
                            />

                        )}

                    </div>


                </div>

            </div>


            {/* PREVIOUS */}

            {slides.length > 1 && (

                <button
                    type="button"
                    className="slider-arrow slider-prev"
                    onClick={prevSlide}
                    aria-label="Previous slide"
                    disabled={isAnimating}
                >

                    &#10094;

                </button>

            )}


            {/* NEXT */}

            {slides.length > 1 && (

                <button
                    type="button"
                    className="slider-arrow slider-next"
                    onClick={nextSlide}
                    aria-label="Next slide"
                    disabled={isAnimating}
                >

                    &#10095;

                </button>

            )}


            {/* DOTS */}

            {slides.length > 1 && (

                <div className="slider-dots">

                    {slides.map((item, index) => (

                        <button
                            type="button"
                            key={item.id}
                            className={
                                current === index
                                    ? "dot active"
                                    : "dot"
                            }
                            onClick={() =>
                                changeSlide(
                                    index,
                                    index > current
                                        ? "next"
                                        : "prev"
                                )
                            }
                            aria-label={
                                `Go to slide ${index + 1}`
                            }
                            disabled={isAnimating}
                        />

                    ))}

                </div>

            )}


        </section>

    );

}


export default HeroSlider;